export const clientGroup = {
    name: '',
    clients: [],
    account: '',
    client: '',
    status: 'ACTIVE',
}
